angular.module('analytics.mixpanel').provider('mixpanel', function () {
  var mixpanelInstance, disabledEvents, disabled;

  // Allow the explicit passing in of a mixpanel object
  this.mixpanel = function (value) {
    mixpanelInstance = value;
  };

  this.token = undefined;
  this.config = {};
  this.libraryName = 'angular';

  // Enables multiple calls to disable events which will be collected then
  // applied during initialization. If disable is called, then it overrides
  // all individual event disabling.
  this.disable = function (events) {
    if (angular.isArray(events)) {
      if (!disabledEvents) disabledEvents = [];
      disabledEvents = disabledEvents.concat(events);
    } else {
      disabled = true;
    }
  };

  this.$get = [
    '$window',
    '$log',
    function ($window, $log) {
      let mixpanelInstance;
      if (!$window.mixpanel) {
        $log.warn('Unable to find mixpanel Instance');
      } else {
        mixpanelInstance = $window.mixpanel;
      }

      return mixpanelInstance;
    },
  ];
});
